import React, { useState, useMemo, useEffect, useRef } from 'react'
import { useTable, useExpanded } from 'react-table'
import MOCK_DATA from './MOCK_DATA.json'
import { COLUMNS } from './columns'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, InputGroupAddon, InputGroupText, Input, Dropdown, DropdownItem, DropdownToggle, DropdownMenu, ListGroup, ListGroupItem, Badge } from 'reactstrap'
import Creatable, { useCreatable } from 'react-select/creatable';
import WishResponse from './WishResponse'
import WishItem from './WishITem'

//import './table.css'

export default function CustomerForm() {
    const [allWisheLists, setAllWisheLists] = useState([{}])
    const columns = useMemo(() => COLUMNS, [])
    //const data = useMemo(() => MOCK_DATA, [])
    const data = useMemo(() => (allWisheLists ? allWisheLists : ''), [allWisheLists]);
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const [disavleAutoExp, setDisavleAutoExp] = useState(false);
    const handleSetDisavleAutoExp = (bool) => { setDisavleAutoExp(bool) }
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        visibleColumns,
        state: { expanded },
    } = useTable(
        {
            columns,
            data,
            autoResetExpanded: disavleAutoExp
        },
        useExpanded // We can useExpanded to track the expanded state
        // for sub components too!
    )

    const [customerName, setCustomerName] = useState([]);
    const customerNames = [{ value: 0, label: 'Sören Thorwirth' }, { value: 1, label: 'Alireza Sepehri' }, { value: 2, label: 'Leonard Kupper' }, { value: 3, label: 'Sina Sanaeidashti' }, { value: 4, label: 'Adriana Zubiate' }, { value: 5, label: 'Tim Berners-Lee' }, { value: 6, label: 'Elon Musk' }, { value: 7, label: 'Bugs Bunny' }]
    const handleCustomerNameChange = (CustomerName) => {
        setCustomerName(CustomerName ? CustomerName.label : '')
    }


    //start of dropdown realated states and function
    const [packingdropdownOpen, setPackingDropdownOpen] = useState(false);
    const packingdropdowntoggle = () =>
        setPackingDropdownOpen((prevState) => !prevState);
    const [packingdropdownValue, setPackingDropdownValue] = useState("select");
    //end of dropdown realated states and function
    const [wishDescription, setWishDescription] = useState('')
    const [wishList, setWishList] = useState([])

    const handleAddWish = () => {
        if (wishDescription.trim()) {
            setWishList(oldArray => [...oldArray, wishDescription]);
            setWishDescription('')
            console.log('wish list: ', wishList)
        } else {
            setWishDescription('')
        }
    }
    const handleDeletItemFromWishList = (index) => {
        setWishList(oldArray => {
            return oldArray.filter((value, i) => i !== index)
        })
        console.log('after filtering: ', wishList)
    }

    //console.log('DATA:', data)

    const handleDeleteWholeWish = async (id) => {
        try {
            const response = await fetch(
                `/api/v1/WatchHunter/wishes/${id}`,
                {
                    method: "DELETE",
                }
            );
            if (response.ok) {
                console.log(response);
                getAllWishLists();
                setDisavleAutoExp(true)
            }
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
        } catch (err) {
            console.error(err);
            // Handle errors here
        } finally {
            console.log("FINALLY");
        }
    };

    useEffect(() => { document.title = "Customer Form"; }, []);
    const [errorMsg, setErrorMsg] = useState('')
    async function handleSaveWishList() {
        try {
            var wishListForApi = wishList.map(wish => ({ Description: wish }));
            if (wishList.length === 0) {
                setErrorMsg("Please at first, add wish(es)")
            }
            if (wishList.length > 0) {
                const response = await fetch(
                    `/api/v1/WatchHunter/Wishes/`,
                    {
                        method: "POST", headers: new Headers({ "Content-Type": "application/json", }),
                        body: JSON.stringify({
                            customerName: customerName,
                            Wishes: wishListForApi,
                        }),
                    }
                );
                if (response.ok) {
                    console.log(response)
                    setWishList([])
                    getAllWishLists()
                    toggle()
                }
                if (!response.ok) {
                    const payload = await response.text();
                    alert(payload);
                }
            }
        } catch (err) {
            console.error(err);
            // Handle errors here
        } finally {
            console.log('FINALLY')
        }
    }
    async function getAllWishLists() {
        try {
            const response = await fetch(
                `/api/v1/WatchHunter/Wishes/`,
                {
                    method: "GET", headers: new Headers({ "Content-Type": "application/json", }),
                }
            );
            if (response.ok) {
                const payload = await response.json();
                //console.log(payload)
                setAllWisheLists(payload)
            }
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
        } catch (err) {
            console.error(err);
            // Handle errors here
        } finally {

        }
    }
    useEffect(() => {
        getAllWishLists()
    }, [])

    useEffect(() => {
        if (wishList.length > 0) {
            setErrorMsg('')
        }
    }, [wishList])

    const [display, setDisplay] = useState(false)
    const [wishResponseData, setWishResponseData] = useState()
    const handleShowResponse = (data) => {
        setWishResponseData(data)
        console.log('SSSSSSS : ', data)
    }
    let totalOffers = 0

    return (
        <>
            <div className='vipView'>
                <div className='d-flex justify-content-between align-items-center'>
                    <Button color='primary' className='ml-0 mb-3' onClick={toggle}>New Record</Button>
                    <h3><Badge color="secondary">VIP-View</Badge></h3>
                </div>
                <div className='d-flex justify-content-between align-items-start'>
                    <table {...getTableProps()} >
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                    ))}

                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {rows.map(row => {
                                prepareRow(row)
                                console.log('ROW: ', row)
                                return (
                                    // Use a React.Fragment here so the table markup is still valid
                                    // eslint-disable-next-line
                                    // {const newRowFragment = {...row.getRowProps()}.map((item)=> {return {key: item.key}})}
                                    <React.Fragment {...row.getRowProps()}>
                                        {console.log({ ...row.getRowProps() })}
                                        <tr>
                                            {row.cells.map(cell => {

                                                if (cell.column.Header === 'Actions') {
                                                    totalOffers = 0
                                                    return (
                                                        <td>
                                                            <div className='d-flex justify-content-between align-items-center'>
                                                                <Button color='danger' onClick={() => { handleDeleteWholeWish(row.original._id) }} outline>Delete List</Button>
                                                                <Button color='success' outline onClick={() => { setDisplay(true); handleShowResponse(cell.row.original) }}><b>
                                                                    <span>
                                                                        {cell.row.original.wishes ?
                                                                            cell.row.original.wishes.map((wish, index) => { totalOffers = parseInt(totalOffers + wish.offers.length * 1); return ((cell.row.original.wishes.length - 1 === index) ? totalOffers : '') })
                                                                            : 'X'}
                                                                    </span> Responses to<span> {cell.row.original.wishes ? cell.row.original.wishes.length : 'X'} </span>wishes</b>
                                                                </Button>
                                                            </div>
                                                        </td>)
                                                } else {
                                                    return (<td {...cell.getCellProps()}>{cell.render('Cell')}</td>)
                                                }
                                            })}

                                        </tr>
                                        {/*
                                    If the row is in an expanded state, render a row with a
                                    column that fills the entire length of the table.
                                    */}
                                        {row.isExpanded ? (
                                            row.original.wishes.map((item, index) => {
                                                return (
                                                    <>
                                                        <tr key={index}>
                                                            <td colSpan={visibleColumns.length}>
                                                                {/*
                                                                Inside it, call our renderRowSubComponent function. In reality,
                                                                you could pass whatever you want as props to
                                                                a component like this, including the entire
                                                                table instance. But for this example, we'll just
                                                                pass the row
                                                            */}
                                                                <WishItem
                                                                    index={index}
                                                                    item={item}
                                                                    row={row}
                                                                    getAllWishLists={() => { getAllWishLists() }}
                                                                    setAutoExpand={handleSetDisavleAutoExp}
                                                                    display={display}
                                                                    setDisplay={setDisplay}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            }
                                            )
                                        )
                                            : null}
                                    </React.Fragment>
                                )
                            })}
                        </tbody>
                    </table>
                    {/*<WishResponse
                        display={display}
                        setDisplay={setDisplay}

                    />*/}
                    {wishResponseData && <div className='d-flex flex-column align-items-start' style={display ? { minWidth: '50%' } : { display: "none", minWidth: '45%' }}>
                        {wishResponseData ?
                            wishResponseData.wishes.map((wish, index) => {
                                return (
                                    <div className='w-100 allResponses' style={display ? {} : {display: 'none'}}>
                                        <div className={`${display ? 'd-flex' : 'd-none'}  justify-content-between align-items-baseline mt-2 w-100 `}>
                                            <h2>
                                                For: <span>{wish.description}</span>
                                            </h2>
                                            {index === 0 && <Button
                                                outline
                                                color="dark"
                                                onClick={() => {
                                                    setDisplay(false);
                                                }}
                                            >
                                                X
                                            </Button>}
                                        </div>
                                        {wish.offers.map((offer, index) => {
                                            return (<WishResponse display={display} setDisplay={setDisplay} offer={offer} />)
                                        })}
                                    </div>
                                )
                            })
                            : ''}
                    </div>}
                </div>
                <Modal isOpen={modal} toggle={toggle} backdrop="static" size='lg'
                //className={this.props.className}
                >
                    <ModalHeader toggle={toggle}>
                        Let the wish become true
                    </ModalHeader>
                    <ModalBody>
                        <div className='d-flex justify-content-between'>
                            <Creatable style={{ overflow: 'auto' }}
                                className='w-50 mr-3  mb-2'
                                isClearable
                                onChange={(value) => handleCustomerNameChange(value)}
                                options={customerNames}
                                placeholder="Customer Name"
                            />
                            <Dropdown isOpen={packingdropdownOpen} toggle={packingdropdowntoggle}>
                                <DropdownToggle caret>
                                    Status
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem
                                    //disabled
                                    >
                                        New
                                    </DropdownItem>
                                    <DropdownItem>On Progress</DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem>Closed</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        <br />
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>Wish</InputGroupText>
                            </InputGroupAddon>
                            <Input
                                value={wishDescription || ''}
                                onChange={(e) => setWishDescription(e.target.value)}
                                //onBlur={() => handleAddWish()}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        handleAddWish()
                                    }
                                }}
                            />
                            <InputGroupAddon style={{ cursor: 'pointer' }} addonType="append" onClick={() => { setWishDescription('') }}>X</InputGroupAddon>
                        </InputGroup>
                        <br />
                        {errorMsg && <p>{errorMsg}</p>}
                        {/*                        <Button color='primary' onClick={() => { alert('Nice, next step is to make it work, and add more input elements for you') }}>Add To Wish List</Button>*/}
                        <ListGroup>
                            {/*wishList.length > 0 && <h4><Badge color="secondary">Wish List</Badge></h4>*/}
                            {
                                wishList && wishList.map((item, index) => {
                                    if (item.trim()) {
                                        return (
                                            <ListGroupItem key={index} className="justify-content-between">{index + 1}. {item} <Badge size='lg' color='danger' className='ml-1' onClick={() => { handleDeletItemFromWishList(index) }}><i className="far fa-trash-alt"></i></Badge></ListGroupItem>
                                        )
                                    }
                                })
                            }
                        </ListGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={handleSaveWishList}>Save The Wish List</Button>{' '}
                        <Button color="secondary" onClick={toggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
            {console.log(wishDescription)}
        </>
    )
}
